import React from "react";
import { TabContainer, TabButton } from "./TabBar.styled";

/**
 * Generic horizontal tab bar.
 *
 * @param {Array<{key:string, label:string}>} tabs — tab definitions
 * @param {string} activeKey — currently active tab key
 * @param {function} onChange — called with key when tab is clicked
 */
const TabBar = ({ tabs = [], activeKey, onChange }) => (
  <TabContainer>
    {tabs.map((t) => (
      <TabButton
        key={t.key}
        $active={t.key === activeKey}
        onClick={() => onChange?.(t.key)}
      >
        {t.label}
      </TabButton>
    ))}
  </TabContainer>
);

export default TabBar;
